import * as React from 'react';


export default class UploadTxt extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (
            <svg className={this.props.className} xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 50 62">
                <defs>
                    <path id="a" d="M48.941 11.596v45.816a2.824 2.824 0 0 1-2.823 2.823H2.824A2.824 2.824 0 0 1 0 57.412V2.824A2.824 2.824 0 0 1 2.824 0h34.522a3 3 0 0 1 2.12.879l8.596 8.595a3 3 0 0 1 .88 2.122z"/>
                </defs>
                <g fill="none" fillRule="evenodd">
                    <g transform="translate(.53 .882)">
                        <use fill="#FFF" xlinkHref="#a"/>
                        <path stroke="#E4E4E4" strokeWidth="2" d="M47.941 11.596a2 2 0 0 0-.586-1.415L38.76 1.586A2 2 0 0 0 37.346 1H2.824A1.824 1.824 0 0 0 1 2.824v54.588c0 1.007.816 1.823 1.824 1.823h43.294a1.824 1.824 0 0 0 1.823-1.823V11.596z"/>
                    </g>
                    <path fill="#5C6FE2" d="M19.456 43.302h-3.578v9.732h-2.407v-9.732h-3.53v-1.95h9.515v1.95zm5.552 2.078l2.19-4.027h2.768l-3.402 5.792 3.49 5.89h-2.8l-2.246-4.092-2.246 4.091h-2.8l3.49-5.889-3.402-5.792h2.768l2.19 4.027zm15.05-2.078h-3.577v9.732h-2.407v-9.732h-3.53v-1.95h9.515v1.95z"/>
                    <path fill="#5C6FE2" d="M6.176 17.823h37.647v4.706H6.176zM6.176 7.47H32.53v4.706H6.176zM6.176 28.176h37.647v4.706H6.176z" opacity=".1"/>
                    <path fill="#5C6FE2" d="M36.884 5.728v6.89a.5.5 0 0 0 .5.5h6.889a.5.5 0 0 0 .354-.854l-6.89-6.89a.5.5 0 0 0-.853.354z"/>
                </g>
            </svg>
        )
    }
}
